import { AuxiliumComponent } from "../auxilium-component";

export class FrameHeader extends AuxiliumComponent {
	constructor() {
		super();

		this.restrictWidth = this.hasAttribute("restrict-width");
	}

	parsedCallback() {
		this.classList.add("layout-frame__header");
		const header = document.createElementWithContents("header", this.childNodes);

		if (this.restrictWidth) {
			header.classList.add("container");
		}

		this.appendChild(header);
	}
}